import { render } from "./PrintedSmallBox.vue?vue&type=template&id=314897d4&scoped=true"
import script from "./PrintedSmallBox.vue?vue&type=script&lang=js"
export * from "./PrintedSmallBox.vue?vue&type=script&lang=js"

import "./PrintedSmallBox.vue?vue&type=style&index=0&id=314897d4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314897d4"]])

export default __exports__